import React, { useEffect } from 'react';
import Template from '../Template/Template';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

export const Initiated = ({ navigateToLinkedBankAccounts, handleClose }) => {
  useEffect(() => {
    dispatchPageLoad('VerificationProgressManual');
  }, []);
  return (
    <Template
      header={`This bank was recently submitted.`}
      nextButton={`Verify Linked Bank Accounts`}
      backButton={`Cancel`}
      onBackClick={handleClose}
      onNextClick={navigateToLinkedBankAccounts}
    >
      T. Rowe Price will make two small deposits of less than $1.00 in this
      account. You will receive an e-mail informing you when this occurs. Then
      you can use the deposit information to complete the verification process.
      <br />
      <br />
      If you did not initiate this request, please send us a secure e-mail
      message or contact T. Rowe Price Customer Service at{' '}
      <a className="phone">(800) 225-5132.</a>
    </Template>
  );
};
